// 최신 버전 에러 타입
export default class ErrorType2 {
    /** 서버 상태 코드 */
    statusCode = 0;
    error = {
        /** 백엔드에서 만든 코드 INVALID_CARD_ORDER */
        errorCode: '',
        /** 메시지 */
        message: '',
        /** BAD_REQUEST...  */
        category: '',
        /** 에러 필드 */
        errorFields: [],
    };
    constructor(error = {}) {
        Object.assign(this, error);
    }
}
